<template>
  <div class="content-background">
    <div class="add-content">
      <div class="content">
        <div>
          <p class="content-label required">分类名称</p>
          <el-input
            clearable
            v-model.trim="name"
            placeholder="请输入分类名称"
            type="text"
            class="content-title-input"
            maxlength="45" :show-word-limit="true"></el-input>
            <span class="limit" v-if="name && name.length > 30">{{name? name.length: 0}}/45</span>
        </div>
        <div>
          <p class="content-label required">分类名称（英文）</p>
          <el-input
            clearable
            v-model.trim="nameEn"
            placeholder="请输入分类名称（英文）"
            type="text"
            class="content-title-input"
            maxlength="45" :show-word-limit="true"></el-input>
            <span class="limit" v-if="nameEn && nameEn.length > 30">{{nameEn? nameEn.length: 0}}/45</span>
        </div>
        <div>
          <p class="content-label">显示在精彩分享页</p>
          <el-switch v-model="status" active-value="1" inactive-value="2"></el-switch>
        </div>
        <div>
          <div class="content-topic-divider"></div>
          <div class="content-footer">
            <el-button class="save" @click="$router.back()">取消</el-button>
            <el-button class="publish" @click="save" v-if="permissions.topic_add">添加</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/content.scss'
import { mapGetters } from 'vuex';
import { addNewTag } from '@/api/basic/topic';

export default {
  data() {
    return {
      name: '',
      nameEn: '',
      tagCode: '',
      sort: 0,
      dictId: 2,
      status: 1,
      value: 1,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    async save () {
      const name = this.name;
      if (name === '' || name.trim() === '') {
        this.$message({
          message: '分类名称不能为空',
          type: 'warning'
        });
        return;
      }
      const nameEn = this.nameEn;
      if (nameEn === '' || nameEn.trim() === '') {
        this.$message({
          message: '分类名称（英文）不能为空',
          type: 'warning'
        });
        return;
      }
      const data = {};
      data.status = this.status;
      data.type = this.dictId;
      data.name = name;
      data.nameEn = nameEn;
      data.tagCode = this.tagCode;
      data.sort = this.sort;
      const response = await this.requestWrapper(addNewTag, data);
      if (!response || response.ok === false) {
        this.$message({
          message: response.message || '新增分类失败',
          type: 'error'
        });
      } else {
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-background {
  .add-content {
    .required::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    .limit {
      font-size: 14px;
      color: #AFAFAF;
      margin-left: 12px;
    }
    .content-area {
      width: 920px;
      position: relative;
      .content-image-input {
        width: 100%;
        position: relative;
      }
      .limit {
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    .content-footer {
      text-align: right;
    }
  }
}
</style>
